module.exports = __webpack_public_path__ + "static/img/科技市场-服务交易-_04.359559b5.png";